/**
 * Numeric values of the Viedoc.Format.Cdisc `MethodType` enum as they appear
 * on the wire.  Newtonsoft serializes the C# enum as its underlying integer,
 * so client code must compare against these numbers rather than the enum
 * member names.
 *
 * @see Viedoc.Format.Cdisc/Odm/MethodType.cs
 */
export const METHOD_TYPE = Object.freeze({
    Computation: 0,
    Imputation: 1,
});

// A machine-computed item: the value comes from a function, not from the
// participant. An Imputation methodDef is not one — it pre-fills a default
// the participant can still edit.
export const isComputationItem = (item) =>
    item?.methodDef?.methodType === METHOD_TYPE.Computation;
